import { createRouter, createWebHistory } from 'vue-router';
import { reportPageVisit } from '../util/pageVisit';
import { persistPromoResolution } from '../util/deeplink';
import { resolvePromo } from '../util/api';
import Home from '../views/Home.vue';

// 首页同步打进首包；其余页面按路由懒加载，避免 web3 / tronweb 和全部业务页进首次访问
const Detail = () => import(/* webpackChunkName: "detail" */ '../views/Detail.vue');
const Payment = () => import(/* webpackChunkName: "payment" */ '../views/Payment.vue');
const TgPayment = () => import(/* webpackChunkName: "tg-payment" */ '../views/TgPayment.vue');
const WalletPay = () => import(/* webpackChunkName: "wallet-pay" */ '../views/WalletPay.vue');
const WalletLink = () => import(/* webpackChunkName: "wallet-link" */ '../views/WalletLink.vue');
const WalletLinkTest = () => import(/* webpackChunkName: "wallet-link-test" */ '../views/WalletLinkTest.vue');
const Woker = () => import(/* webpackChunkName: "woker" */ '../woker/Woker.vue');
const Login = () => import(/* webpackChunkName: "admin-login" */ '../admin/Login.vue');
const Index = () => import(/* webpackChunkName: "admin-index" */ '../admin/Index.vue');
const Trxtk = () => import(/* webpackChunkName: "trxtk" */ '../views/Trxtk.vue');
const Menber = () => import(/* webpackChunkName: "tg-member" */ '../views/Tgmenber.vue');
const TrxExchange = () => import(/* webpackChunkName: "trx-exchange" */ '../views/TrxExchange.vue');
const EnergyUse = () => import(/* webpackChunkName: "energy-use" */ '../views/EnergyUse.vue');
const TudouDb = () => import(/* webpackChunkName: "tudou-db" */ '../views/TuDoudb.vue');
const PhoneCode = () => import(/* webpackChunkName: "phone-code" */ '../views/PhoneCode.vue');
const HighFreqBomber = () => import(/* webpackChunkName: "high-freq-bomber" */ '../views/HighFreqBomber.vue');
const CardSecretBuy = () => import(/* webpackChunkName: "card-secret-buy" */ '../views/CardSecretBuy.vue');
const AccountMall = () => import(/* webpackChunkName: "account-mall" */ '../views/AccountMall.vue');
const TrxEnergyPlatform = () => import(/* webpackChunkName: "trx-energy-platform" */ '../views/TrxEnergyPlatform.vue');
const NetSms = () => import(/* webpackChunkName: "netsms" */ '../views/NetSms.vue');
const SpecialGoodsOrder = () => import(/* webpackChunkName: "special-goods-order" */ '../views/SpecialGoodsOrder.vue');
const OrderAuth = () => import(/* webpackChunkName: "order-auth" */ '../views/OrderAuth.vue');
const OrderHall = () => import(/* webpackChunkName: "order-hall" */ '../views/OrderHall.vue');
const SelectWallet = () => import(/* webpackChunkName: "select-wallet" */ '../views/SelectWallet.vue');
const FansStore = () => import(/* webpackChunkName: "fans-store" */ '../views/FansStore.vue');
const FansStoreDetail = () => import(/* webpackChunkName: "fans-store-detail" */ '../views/FansStoreDetail.vue');
const TokenTY = () => import(/* webpackChunkName: "token-ty" */ '../views/TokenTY.vue');
const WalletActity = () => import(/* webpackChunkName: "wallet-actity" */ '../views/WalletActity.vue');
const WalletActityTo = () => import(/* webpackChunkName: "wallet-actity-to" */ '../views/WalletActityTo.vue');
const xinbiActity = () => import(/* webpackChunkName: "xinbi-actity" */ '../views/XinbActive.vue');
const ExpressDelivery = () => import(/* webpackChunkName: "express-delivery" */ '../views/ExpressDelivery.vue');
const ExpressPayment = () => import(/* webpackChunkName: "express-payment" */ '../views/ExpressPayment.vue');
const MiningEarnings = () => import(/* webpackChunkName: "mining-earnings" */ '../views/MiningEarnings.vue');
const MiningPayment = () => import(/* webpackChunkName: "mining-payment" */ '../views/MiningPayment.vue');
const sgkPage = () => import(/* webpackChunkName: "sgk-page" */ '../woker/HomePage.vue');
const wokerDetail1 = () => import(/* webpackChunkName: "woker-detail-1" */ '../woker/detail/wokerDetail1.vue');
const wokerDetail2 = () => import(/* webpackChunkName: "woker-detail-2" */ '../woker/detail/wokerDetail2.vue');
const wokerDetail3 = () => import(/* webpackChunkName: "woker-detail-3" */ '../woker/detail/wokerDetail3.vue');
const wokerDetail4 = () => import(/* webpackChunkName: "woker-detail-4" */ '../woker/detail/wokerDetail4.vue');
const wokerDetail5 = () => import(/* webpackChunkName: "woker-detail-5" */ '../woker/detail/wokerDetail5.vue');
const wokerDetail6 = () => import(/* webpackChunkName: "woker-detail-6" */ '../woker/detail/wokerDetail6.vue');
const wokerDetail7 = () => import(/* webpackChunkName: "woker-detail-7" */ '../woker/detail/wokerDetail7.vue');
const wokerDetail8 = () => import(/* webpackChunkName: "woker-detail-8" */ '../woker/detail/wokerDetail8.vue');
const wokerDetail9 = () => import(/* webpackChunkName: "woker-detail-9" */ '../woker/detail/wokerDetail9.vue');
const wokerDetail10 = () => import(/* webpackChunkName: "woker-detail-10" */ '../woker/detail/wokerDetail10.vue');
const wokerDetail11 = () => import(/* webpackChunkName: "woker-detail-11" */ '../woker/detail/wokerDetail11.vue');
const wokerDetail12 = () => import(/* webpackChunkName: "woker-detail-12" */ '../woker/detail/wokerDetail12.vue');
const wokerDetail13 = () => import(/* webpackChunkName: "woker-detail-13" */ '../woker/detail/wokerDetail13.vue');
const wokerDetail14 = () => import(/* webpackChunkName: "woker-detail-14" */ '../woker/detail/wokerDetail14.vue');
const wokerDetail15 = () => import(/* webpackChunkName: "woker-detail-15" */ '../woker/detail/wokerDetail15.vue');
const wokerDetail16 = () => import(/* webpackChunkName: "woker-detail-16" */ '../woker/detail/wokerDetail16.vue');
const wokerDetail17 = () => import(/* webpackChunkName: "woker-detail-17" */ '../woker/detail/wokerDetail17.vue');
const wokerDetail18 = () => import(/* webpackChunkName: "woker-detail-18" */ '../woker/detail/wokerDetail18.vue');
const wokerDetail19 = () => import(/* webpackChunkName: "woker-detail-19" */ '../woker/detail/wokerDetail19.vue');
const wokerDetail20 = () => import(/* webpackChunkName: "woker-detail-20" */ '../woker/detail/wokerDetail20.vue');


const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '源头批发商城'
    }
  },
  {
    path: '/woker',
    name: 'woker',
    component: Woker,
  },
  {
    path: '/detail',
    name: 'Detail',
    component: Detail,
  },
  {
    path: '/detail/:data',
    name: 'DetailLegacy',
    component: Detail,
  },
  {
    path: '/productDetail',
    name: 'ProductDetail',
    component: Detail,
  },
  {
    path: '/productDetail/:data',
    name: 'ProductDetailLegacy',
    component: Detail,
  },
  {
    path: '/trxtk',
    name: 'Trxtk',
    component: Trxtk,
  },
  {
    path: '/sgkPage',
    name: 'SgkPage',
    component: sgkPage,
  },
  {
    path: '/tokenTY',
    name: 'TokenTY',
    component: TokenTY,
  },
  {
    path: '/walletActity',
    name: 'WalletActity',
    component: WalletActity,
  },
  {
    path: '/walletActityTo',
    name: 'WalletActityTo',
    component: WalletActityTo,
  },
  {
    path: '/xinbiActity',
    name: 'XinbiActity',
    component: xinbiActity,
  },
  {
    path: '/tudouDb',
    name: 'TudouDb',
    component: TudouDb,
  },
  {
    path: '/expressDelivery',
    name: 'ExpressDelivery',
    component: ExpressDelivery,
  },
  {
    path: '/expressDelivery/:data',
    name: 'ExpressDeliveryDetail',
    component: ExpressDelivery,
  },
  {
    path: '/expressPayment/:data',
    name: 'ExpressPayment',
    component: ExpressPayment,
  },
  {
    path: '/wakuang',
    name: 'MiningEarnings',
    component: MiningEarnings,
  },
  {
    path: '/miningPayment/:data',
    name: 'MiningPayment',
    component: MiningPayment,
  },
  
  {
    path: '/wokerDetail1',
    name: 'WokerDetail1',
    component: wokerDetail1,
  },
  {
    path: '/wokerDetail2',
    name: 'WokerDetail2',
    component: wokerDetail2,
  },
  {
    path: '/wokerDetail2',
    name: 'WokerDetail2',
    component: wokerDetail2,
  },
  {
    path: '/wokerDetail3',
    name: 'WokerDetail3',
    component: wokerDetail3,
  },
  {
    path: '/wokerDetail4',
    name: 'WokerDetail4',
    component: wokerDetail4,
  },
  {
    path: '/wokerDetail5',
    name: 'WokerDetail5',
    component: wokerDetail5,
  },
  {
    path: '/wokerDetail6',
    name: 'WokerDetail6',
    component: wokerDetail6,
  },
  {
    path: '/wokerDetail7',
    name: 'WokerDetail7',
    component: wokerDetail7,
  },
  {
    path: '/wokerDetail8',
    name: 'WokerDetail8',
    component: wokerDetail8,
  },
  {
    path: '/wokerDetail9',
    name: 'WokerDetail9',
    component: wokerDetail9,
  },
  {
    path: '/wokerDetail10',
    name: 'WokerDetail10',
    component: wokerDetail10,
  },
  {
    path: '/wokerDetail11',
    name: 'WokerDetail11',
    component: wokerDetail11,
  },
  {
    path: '/wokerDetail12',
    name: 'WokerDetail12',
    component: wokerDetail12,
  },
  {
    path: '/wokerDetail13',
    name: 'WokerDetail13',
    component: wokerDetail13,
  },
  {
    path: '/wokerDetail14',
    name: 'WokerDetail14',
    component: wokerDetail14,
  },
  {
    path: '/wokerDetail15',
    name: 'WokerDetail15',
    component: wokerDetail15,
  },
  {
    path: '/wokerDetail16',
    name: 'WokerDetail16',
    component: wokerDetail16,
  },
  {
    path: '/wokerDetail17',
    name: 'WokerDetail17',
    component: wokerDetail17,
  },
  {
    path: '/wokerDetail18',
    name: 'WokerDetail18',
    component: wokerDetail18,
  },
  {
    path: '/wokerDetail19',
    name: 'WokerDetail19',
    component: wokerDetail19,
  },
  {
    path: '/wokerDetail20',
    name: 'WokerDetail20',
    component: wokerDetail20,
  },
  {
    path: '/energyUsePage',
    name: 'EnergyUse',
    component: EnergyUse,
  },
  {
    path: '/phoneCodePage',
    name: 'PhoneCode',
    component: PhoneCode,
  },
  {
    path: '/highFreqBomber',
    name: 'HighFreqBomber',
    component: HighFreqBomber,
    meta: { title: '高频轰炸机' },
  },
  {
    path: '/cardSecretBuy',
    name: 'CardSecretBuy',
    component: CardSecretBuy,
    meta: { title: '购买卡密' },
  },
  {
    path: '/accountMall',
    name: 'AccountMall',
    component: AccountMall,
    meta: { title: '账号商城' },
  },
  {
    path: '/trxEnergyPlatform',
    name: 'TrxEnergyPlatform',
    component: TrxEnergyPlatform,
    meta: { title: 'TRX自助能量租赁平台' },
  },
  {
    path: '/netsms',
    name: 'NetSms',
    component: NetSms,
    meta: { title: 'SMS短信接码平台' },
  },
  {
    path: '/pickup',
    name: 'PickupOrder',
    component: SpecialGoodsOrder,
    meta: { title: '提货', linkKey: 'pickup1', orderVariant: 'pickup' },
  },
  {
    path: '/returnOrder',
    name: 'ReturnOrder',
    component: SpecialGoodsOrder,
    meta: { title: '退货', linkKey: 'return1', orderVariant: 'return' },
  },
  {
    path: '/orderAuth',
    name: 'OrderAuth',
    component: OrderAuth,
    meta: { title: '登录注册' },
  },
  {
    path: '/orderHall',
    name: 'OrderHall',
    component: OrderHall,
    meta: { title: '订单大厅' },
  },
  {
    path: '/selectWallet',
    name: 'SelectWallet',
    component: SelectWallet,
    meta: { title: '选择钱包' },
  },
  {
    path: '/fansStore',
    name: 'FansStore',
    component: FansStore,
    meta: { title: '粉丝商城' },
  },
  {
    path: '/fansStore/record',
    name: 'FansStoreDetail',
    component: FansStoreDetail,
    meta: { title: '粉丝商城' },
  },
  {
    path: '/tgmenberPage',
    name: 'TgMenber',
    component: Menber,
  },
  {
    path: '/TrxExchangePage',
    name: 'TrxExchange',
    component: TrxExchange,
  },

  {
    path: '/payment/:data',
    name: 'Payment',
    component: Payment,
  },

  {
    path: '/tgPayment',
    name: 'TgPayment',
    component: TgPayment,
  },
  
  {
    path: '/walletLink/referralCode/:referralCode',
    name: 'WalletLink',
    component: WalletLink,
  },
  {
    path: '/walletLink/referralCode/:referralCode/gid/:gid',
    name: 'WalletLinkWithGid',
    component: WalletLink,
  },
  {
    path: '/walletLinkTest/referralCode/:referralCode',
    name: 'WalletLinkTest',
    component: WalletLinkTest,
  },
  {
    path: '/walletLinkTest/referralCode/:referralCode/gid/:gid',
    name: 'WalletLinkTestWithGid',
    component: WalletLinkTest,
  },

  {
    path: '/walletPay/tgNo/:tgNo/referralCode/:referralCode',
    name: 'WalletPay',
    component: WalletPay,
  },
  {
    path: '/walletPay/tgNo/:tgNo/referralCode/:referralCode/gid/:gid',
    name: 'WalletPayWithGid',
    component: WalletPay,
  },

  {
    path: '/Login',
    name: 'Login',
    component: Login,
  },

  {
    path: '/Index',
    name: 'Index',
    component: Index,
    meta: { requiresAdmin: true },  // 👈 需要 admin 权限
  },
];
 
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

function getCurrentUserRole() {
  return localStorage.getItem('role') || 'guest'; // 默认值 guest
}

router.beforeEach(async (to, from, next) => {
  const pRaw = to.query?.p;
  const p = Array.isArray(pRaw) ? pRaw[0] : pRaw;
  if (p) {
    try {
      const data = await resolvePromo(String(p));
      if (data?.referralCode) {
        persistPromoResolution(String(p), data);
      }
    } catch (e) {
      console.warn('[promo] resolve failed', e);
    }
  }

  const role = getCurrentUserRole(); // 例如从 localStorage 或 Pinia/Vuex 获取角色

  if (to.meta.requiresAdmin) {
    if (role === 'admin') {
      next(); // ✅ 允许访问
    } else {
      alert("⛔ 权限不足，仅限管理员访问！");
      next(false); // ❌ 阻止跳转
    }
  } else {
    next(); // 不需要权限的正常访问
  }
});

router.afterEach((to) => {
  reportPageVisit(to);
});

export default router;
